module.exports = require("style-loader");